//	@ts-ignore
import load from 'load-script';
import { IReCaptcha } from './types';

export const ReCaptcha: IReCaptcha = {
  isEnabled(engine) {
    return Boolean(engine.getSurveyData().re_captcha);
  },
  initial: engine =>
    new Promise(resolve => {
      if (ReCaptcha.isEnabled(engine)) {
        const onLoad = 'onReCaptchaLoad';
        load(
          `https://www.google.com/recaptcha/api.js?onload=${onLoad}&render=explicit`
        );
        //	@ts-ignore
        window[onLoad] = () => resolve();
      } else {
        resolve();
      }
    })
};
